
// Error messages
const ErrorCodes = {
  2: 'Blank App ID',
  11: 'Problem with payload',
  17: 'invalid App ID',
  401: 'Token has Expired',
  516: 'Invalid Payload',
  517: 'Invalid Payload',
  521: 'Token Unavailable',
  527: 'Invalid Date Format',
  1004: 'Invalid Request Payload',
  1701: 'vAtom Unrecognized',
  1708: 'vAtom Unvailable',
  2030: 'No user found, please register an account first.',
  2031: 'Authentication Failed',
  2032: 'Incorrect password, please try again.',
  2034: 'Invalid Token',
  2037: 'Upload Avatar Failed',
  2049: 'Refresh Token Expired / Not Whitelisted',
  2051: 'Too many login attempts, please try again later.',
  2552: 'Unable To Retrieve Token',
  2553: 'Token ID Invalid',
  2562: 'Cannot Delete Primary Token',
  2563: 'Token Already Confirmed',
  2564: 'Invalid Verification Code',
  2566: 'Token Already Confirmed',
  2567: 'Invalid Verification Code',
  2569: 'Invalid Token Type',
  2571: 'Invalid Email',
  2572: 'Invalid Phone Number',
  2586: 'Unverified Token'
}

export default class BLOCKv {

  /**
   *  Returns the response from a server request.
   *
   *  @returns {Promise<Object>} The server's response.
   */
  static request(method, endpoint, body, headers = {}, server = BLOCKv.server) {

    // Setup headers
    if (!headers['App-Id']) headers['App-Id'] = BLOCKv.AppID
    headers['Content-Type'] = 'application/json'

    // Make sure data is a string
    if (body && typeof body == 'object')
      body = JSON.stringify(body)

    // Send request
    return fetch(server + endpoint, { method, headers, body }).then(r => r.json()).then(response => {

      // Check for the special login locked error
      // We need to pull the timestamp that is in the reponse.message to show when they
      // can login again
      if (response.error == 2051) {

        // HACK: Pull time from original server error string
        let dateString = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/g.exec(response.message)
        let lockedUntil = new Date(dateString)
        let message = "Too many login attempts, please try again in %DURATION%."

        // Replace duration in the error message
        let duration = lockedUntil.getTime() - Date.now()
        if (duration < 2000) duration = 2000
        const seconds = Math.floor(duration / 1000)
        const minutes = Math.floor(duration / 1000 / 60)
        if (seconds <= 90) {
          message = response.message.replace('%DURATION%', seconds === 1 ? '1 second' : `${seconds}  seconds`)
        } else {
          message = response.message.replace('%DURATION%', minutes === 1 ? '1 minute' : `${minutes} minutes`)
        }

        // Throw error
        const error = new Error(message)
        error.code = response.error || 0
        throw error

      } else if (!response.payload) {

        // No payload, some other error must have happened
        let error = new Error(ErrorCodes[response.error] || response.message || 'An unknown server error has occurred')
        error.code = response.error || response.httpStatus || 0
        throw error

      } else {

        // No error
        return response.payload

      }

    })

  }

  static getAccessToken(refreshToken) {
    return BLOCKv.request('POST', '/v1/access_token', undefined, {
      Authorization: 'Bearer ' + refreshToken
    }).then(data => {
      return data.access_token.token
    });
  }

}

/** These should be set before usage */
BLOCKv.AppID = null
BLOCKv.server = ""